import styled from 'styled-components/macro';
import { ResultsBox } from '../../../../../../../tools/SearchPage/Search.styles';
import * as colors from '../../../../../../../common/colorConstants';

const ResultsHeaderColumn = styled.div`
  font-family: lato, sans-serif;
  line-height: 1.8rem;
  width: 100%;
  font-size: 9px;
  display: inline-flex;
  align-items: center;
  padding-right: 10px;
`;

const ResultsHeaderRow = styled.div`
  padding: 8px 0px 8px 58px;
  line-height: 1.42857143;
  vertical-align: top;
  color: ${colors.darkGray9} !important;
  display: flex;
`;

const Results = styled(ResultsBox)`
  padding: 30px;
`;

export { ResultsHeaderColumn, ResultsHeaderRow, Results };
